export enum InstructionalSequenceTypesEnum {
   OWNER = 'owner',
   SHARED = 'shared',
   GLOBAL = 'global',
}
